import { affiliateValues, setNewCompany } from "core/utils/constants";
import { Companies } from "core/utils/constants";
import { Cookies } from "react-cookie";
import Intercom from "@intercom/messenger-js-sdk";

export class Auth {
  #cookie;

  constructor() {
    this.init();
  }

  init() {
    this.initCookie();
  }

  setSessionid(sessionid) {
    this.setCookie("sessionid", sessionid);
  }

  getCompanyDetail(affiliateValues) {
    let result = "";
    Object.entries(Companies).forEach(([key]) => {
      if (Companies[key].aff_name === affiliateValues.idev_username) {
        result = Companies[key];
      }
    });
    return result;
  }

  setNewCompany(affiliateValues) {
    setNewCompany["aff_name"] = affiliateValues.idev_username;
    setNewCompany["name"] = affiliateValues.idev_username;
    setNewCompany["aff_id"] = affiliateValues.aff_id
      ? affiliateValues.aff_id
      : 0;
    return setNewCompany;
  }
  getAffiliateDetails() {
    const paramSearch = window !== undefined ? window.location.search : "";
    let paramString = paramSearch.split("?")[1];
    let queryString = new URLSearchParams(paramString);
    Object.keys(affiliateValues).forEach((affiliateKey) => {
      if (queryString.has(affiliateKey)) {
        affiliateValues[affiliateKey] = queryString.get(affiliateKey);
      }
    });
    const final_result = this.getCompanyDetail(affiliateValues)
      ? this.getCompanyDetail(affiliateValues)
      : this.setNewCompany(affiliateValues);
    return final_result;
  }

  setAffiliateCookies(affiliateValues) {
    Object.keys(affiliateValues).forEach((affiliateKey) => {
      if (
        affiliateValues.hasOwnProperty(affiliateKey) &&
        affiliateValues[affiliateKey] !== ""
      ) {
        this.setCookie(affiliateKey, affiliateValues[affiliateKey]);
      }
    });
  }

  setStorage(name, value) {
    localStorage.setItem(name, value);
  }

  clearStorage() {
    localStorage.clear();
  }

  clearSessionid() {
    this.removeCookie("sessionid");
  }

  clearAffiliates() {
    Object.keys(affiliateValues).forEach((affiliateKey) => {
      if (
        affiliateValues.hasOwnProperty(affiliateKey) &&
        affiliateValues[affiliateKey] !== ""
      ) {
        this.removeCookie(affiliateKey);
      }
    });
  }

  setUser(user) {
    this.setCookie("refreshToken", user.refresh_token);
    this.setCookie("accessToken", user.access_token);
    this.setCookie("expiresIn", user.expires_in);
  }

  initCookie() {
    if (!this.cookie) {
      this.cookie = new Cookies();
    }
  }

  setCookie(key, value) {
    this.cookie.set(key, value, { domain: ".gosimpletax.com", path: "/" });
  }

  removeCookie(key) {
    this.cookie.remove(key, { domain: ".gosimpletax.com", path: "/" });
  }

  removeAllCookies() {
    const allCookies = Object.keys(this.cookie.getAll());
    allCookies.forEach((cookieItem) => {
      this.removeCookie(cookieItem);
    });
  }

  getToken(name) {
    return this.cookie.get(name);
  }
  //reverted the intercom changes due to duplicate function declarations.
  // setUser(user) {
  //   localStorage.setItem("user", JSON.stringify(user));
  // }

  getUser() {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  }

  initIntercom(user) {
    if (user) {
      Intercom({
        app_id: process.env.REACT_APP_INTERCOM_APP_ID,
        user_id: user.id,
        name: user.name,
        email: user.email,
        created_at: Math.floor(new Date(user.createdAt).getTime() / 1000),
      });
    } else {
      Intercom({ app_id: process.env.REACT_APP_INTERCOM_APP_ID });
    }
  }

  clearAll() {
    this.clearSessionid();
    this.clearAffiliates();
    this.clearStorage();
  }
}

export const AuthService = new Auth();
